import { FhirBundleSdk } from "@metriport/fhir-sdk";
import type { CareGap } from "../../../../api/care-gaps";
import type { Suspect } from "../../../../api/suspects";
import { metadata as allergyMetadata } from "../tables/allergy";
import { metadata as carePlanMetadata } from "../tables/care-plan";
import { metadata as careTeamMetadata } from "../tables/care-team";
import { metadata as conditionMetadata } from "../tables/condition";
import { metadata as coverageMetadata } from "../tables/coverage";
import { metadata as encounterMetadata } from "../tables/encounter";
import { metadata as familyHistoryMetadata } from "../tables/family-history";
import { metadata as immunizationMetadata } from "../tables/immunization";
import { metadata as labMetadata } from "../tables/lab";
import { metadata as medicationMetadata } from "../tables/medication";
import { diagnosticReportMetadata, imagingReportMetadata } from "../tables/notes";
import { metadata as procedureMetadata } from "../tables/procedure";
import { metadata as rawDocumentsMetadata } from "../tables/raw-documents";
import { metadata as relatedPersonMetadata } from "../tables/related-person";
import { metadata as socialHistoryMetadata } from "../tables/social-history";
import { metadata as surveyMetadata } from "../tables/survey";
import { metadata as vitalMetadata } from "../tables/vital";

export type TableRow = {
  id: string;
  originalData?: unknown;
  [key: string]: unknown;
};

export type TableMetadata = {
  tableType: string;
  displayName: string;
  getRows: (bundle: FhirBundleSdk, suspects?: Suspect[], careGaps?: CareGap[]) => TableRow[];
  /** Optional custom function to build searchable text for FlexSearch indexing */
  getSearchableText?: (row: Record<string, unknown>) => string;
};

/**
 * Metadata for all patient overview tables.
 * Defines table identifiers, display names, and data fetching logic.
 * Used for FlexSearch indexing and global filtering.
 *
 * Each table's metadata is colocated with its implementation in tables/[table-name]/metadata.ts
 */
export const TABLE_METADATA_FOR_INDEXING: TableMetadata[] = [
  diagnosticReportMetadata,
  imagingReportMetadata,
  conditionMetadata,
  medicationMetadata,
  allergyMetadata,
  procedureMetadata,
  labMetadata,
  vitalMetadata,
  surveyMetadata,
  socialHistoryMetadata,
  immunizationMetadata,
  carePlanMetadata,
  familyHistoryMetadata,
  relatedPersonMetadata,
  coverageMetadata,
  encounterMetadata,
  careTeamMetadata,
  rawDocumentsMetadata,
];
